import { withInstall } from '@lit-element/utils'

import Overflow from './src/overflow.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtOverflow: SFCWithInstall<typeof Overflow> = withInstall(Overflow)
export default LtOverflow

export * from './src/overflow'
